import type { ButtonHTMLAttributes, ReactNode } from "react";
import { cx } from "@/lib/cx";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "default" | "primary" | "ghost" | "danger";
  block?: boolean;
  children: ReactNode;
}

/** Alvo de toque >= 44px (RF-UX-068); sem depender de hover (RF-UX-069). */
export function Button({ variant = "default", block, className, children, ...rest }: ButtonProps) {
  return (
    <button
      type="button"
      className={cx(
        "btn",
        variant === "primary" && "primary",
        variant === "ghost" && "ghost",
        variant === "danger" && "danger",
        block && "block",
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  );
}
